<div class=" p-3">
    <app-data-table [columns]="cols" [data]="data" title="Data Master" [url]="'/master/master-data/'" [isEditable]="'/master/data-master' | hasPermission: 'Edit'"  [isDeletable]="'/master/data-master' | hasPermission: 'Delete'"  [showAddButton]="'/master/data-master' | hasPermission: 'Add'"  [isView]="'/master/data-master' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
        (editEventRow)="updateSystem($event)" (onAdd)="addSystem()" (onLazyLoadData)="ongetEOI($event)" [totalRecords]="totalRecords"
        (deleteEventRow)="showDeletePopup($event)"></app-data-table>

</div>



<p-dialog header="Create Step Data" [(visible)]="showDialog" [modal]="true" [style]="{width: '800px' , height:'550px'}"
    [closable]="true" [dismissableMask]="true"
    [contentStyle]="{'display': 'flex', 'flexDirection': 'column', 'height': '100%' , 'justify-content' : 'space-between'}"
    [draggable]="true" [resizable]="true" [maximizable]="true">

    <!-- Single row: Dropdown + Radio buttons (Editor / Document Upload) -->
    <div class="create-step-row">
        <div class="create-step-dropdown-cell">
            <label class="create-step-label">Select Type :</label>
            <p-dropdown [options]="documentTypes" [(ngModel)]="selectedType" placeholder="Select Type" [filter]="true"
                filterBy="label" optionLabel="label" styleClass="create-step-dropdown" [style]="{'width':'100%'}">
            </p-dropdown>
        </div>
        <div class="create-step-radio-cell">
            <label class="create-step-label create-step-radio-label">Format :</label>
            <div class="create-step-radio-group">
                <p-radioButton name="stepFormat" value="editor" [(ngModel)]="selectedFormat" inputId="format_editor"></p-radioButton>
                <label for="format_editor" class="radio-label">Include Editor (rich text)</label>
                <p-radioButton name="stepFormat" value="document" [(ngModel)]="selectedFormat" inputId="format_document" class="ms-3"></p-radioButton>
                <label for="format_document" class="radio-label">Attach document (file upload)</label>
            </div>
        </div>
    </div>

    <!-- Rich text editor - shown when "Include comment" is selected -->
    <div class="create-step-editor-section mb-4" *ngIf="selectedFormat === 'editor'">
        <form [formGroup]="stepForm">
            <div class="form-group mb-0 editor-container">
                <label class="bg-primary text-white p-2 d-block mb-0" for="stepCommentEditor"><strong>Data <b class="text-danger">*</b></strong></label>
                <editor id="stepCommentEditor" [init]="init" formControlName="comment"></editor>
            </div>
        </form>
    </div>

    <!-- Choose file option - shown when "Attach document" is selected -->
    <div class="create-step-upload-section mb-4" *ngIf="selectedFormat === 'document'">
        <label class="create-step-label mb-2">Choose File</label>
        <p-fileUpload mode="basic" chooseLabel="Choose File" accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            [auto]="true" [maxFileSize]="209715200" [customUpload]="true" [multiple]="false"
            (uploadHandler)="onUpload($event)" #fileUpload styleClass="p-button-outlined w-100">
        </p-fileUpload>
        <div class="mt-3" *ngIf="selectedFinalOfferFile">
            <div class="d-flex justify-content-between align-items-center">
                <span>{{ selectedFinalOfferFile.name }}</span>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearUpload()" title="Remove File">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>
    </div>

    <!-- Commented out: original Upload Format section (do not remove)
    <div class=" mb-4">
        <div class="col-md-12">
            <div class="card p-3">
                <h5>Upload Format</h5>
                <app-upload-document></app-upload-document>
                <div class="mt-3" *ngIf="finalOfferFilePath ">
                    <div class="d-flex justify-content-between align-items-center">
                        <a [href]="apiUrl + finalOfferFilePath" target="_blank">
                            {{ extractFileName(finalOfferFilePath) }}
                        </a>
                        <button class="btn btn-sm" title="View File">
                            <a [href]="apiUrl + finalOfferFilePath" target="_blank">
                                <i class="pi pi-eye"></i>
                            </a>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    -->
    <!-- <div *ngIf="selectedType?.value === 'eoi'">

    <hr>
    <form [formGroup]="eoiForm">

           
        <div class="mb-4 editor-container">
            <label class="mb-2 d-block">Expression of Interest (EoI)  <b class="text-danger">*</b> 
                </label>
           
            <ckeditor [editor]="Editor" [config]="ckEditorConfig" formControlName="comment"></ckeditor>
            <div *ngIf="eoiForm.get('comment')?.touched && eoiForm.get('comment')?.invalid" class="text-danger">
                Expression of Interest is required.
              </div>
            
        </div>
        <div class="d-flex align-items-end flex-column ">
            <h5>Annexure I to Appendix E</h5>
            <h6>(Refers to Para 9(a) of Appendix E)</h6>
    
        </div>
        <div class="d-flex justify-content-between my-4">
            <h5 >INFORMATION PROFORMA: AN ILLUSTRATIVE LIST OF ELEMENTS  </h5>
    
        </div>
        <div class="mb-4 editor-container">
            <label class="mb-2 d-block">Expression of Interest (EoI)  <b class="text-danger">*</b> 
                </label>
           
            <ckeditor [editor]="Editor" [config]="ckEditorConfig" formControlName="comment_2"></ckeditor>
            <div *ngIf="eoiForm.get('comment_2')?.touched && eoiForm.get('comment_2')?.invalid" class="text-danger">
                Expression of Interest is required.
              </div>
            
        </div>
    </form>
    <div class="d-flex align-items-end flex-column ">
        <h5>Annexure II to Appendix E</h5>
        <h6>(Refers to Para 9(b) of Appendix E)</h6>

    </div>
    <div class="d-flex justify-content-between my-4">
        <h5 >DOCUMENTS/INFORMATION TO BE SUBMITTED AS PART OF RESPONSES TO EoI : AN ILLUSTRATIVE LIST  </h5>
        <p-button label="Row" size="small" [outlined]="true" (onClick)="addRow()" icon="pi pi-plus"></p-button>

    </div>
    
    
    <p-table [value]="reqDoc" class="mb-4">
        <ng-template #header>
            <tr>
                <th width="10%">Sr. No</th>
                <th width="80%">Name</th>
                <th width="10%">Action</th>
    
            </tr>
        </ng-template>
        <ng-template #body let-product let-i="rowIndex">
            <ng-container *ngIf="product.edit">
                <tr>
                    <td>{{ i + 1 }}</td>
                    <td>
                        <textarea 
                          [(ngModel)]="product.name"
                          rows="3"
                          wrap="soft"
                        
                        ></textarea>
                    </td>
                    <td>
                        <p-button label="Save" size="small" [outlined]="true" (onClick)="product.edit = false"
                            icon="pi pi-save"></p-button>
    
                    </td>
                </tr>
            </ng-container>
    
            <ng-container *ngIf="!product.edit">
                <tr>
                    <td>{{ i + 1 }}</td>
                    <td><span [innerText]="product.name"></span></td>
                    <td>
                        <p-button label="Edit" size="small" [outlined]="true" (onClick)="product.edit = true"
                            icon="pi pi-pencil"></p-button>
                    </td>
                </tr>
            </ng-container>
        </ng-template>
    
    </p-table>
</div> -->
    <!-- <div *ngIf="selectedType?.value === 'soc'">
    <form [formGroup]="socForm">
    <div class="mb-4 editor-container">
        <label class="mb-2 d-block">Comment <b class="text-danger">*</b> 
            </label>
       
        <ckeditor [editor]="Editor" [config]="ckEditorConfig" formControlName="comment"></ckeditor>
        <div *ngIf="socForm.get('comment')?.touched && socForm.get('comment')?.invalid" class="text-danger">
            Comment is required.
          </div>
    </div>
    </form>
  </div> -->

    <!-- <div *ngIf="selectedType?.value === 'sotr'">
    <form [formGroup]="sotrForm">
    <div class="mb-4 editor-container">
        <label class="mb-2 d-block">Comment <b class="text-danger">*</b> 
            </label>
       
        <ckeditor [editor]="Editor" [config]="ckEditorConfig" formControlName="comment"></ckeditor>
        <div *ngIf="sotrForm.get('comment')?.touched && sotrForm.get('comment')?.invalid" class="text-danger">
            Comment is required.
          </div>
    </div>
    </form>
  </div> -->

    <!-- <div *ngIf="selectedType?.value === 'rfp'">
    <form [formGroup]="rfpForm">
    <div class="mb-4 editor-container">
        <label class="mb-2 d-block">Comment <b class="text-danger">*</b> 
            </label>
       
        <ckeditor [editor]="Editor" [config]="ckEditorConfig" formControlName="comment"></ckeditor>
        <div *ngIf="rfpForm.get('comment')?.touched && rfpForm.get('comment')?.invalid" class="text-danger">
           Comment is required.
          </div>
    </div>
    </form>
  </div> -->
    <div class="d-flex justify-content-end mt-4">
        <button type="submit" class="btn btn-primary me-2" (click)="onFormsubmit()" *ngIf="selectedType?.value == 'eoi' || selectedType?.value == 'soc' || selectedType?.value == 'sotr' 
    || selectedType?.value == 'rfp' ">Submit</button>
    </div>
</p-dialog>



<p-dialog  [header]="viewMode ? 'View Step Data' : 'Edit Step Data'" [(visible)]="editMode" [modal]="true" [style]="{width: '800px' , height:'550px'}"
    [closable]="true" [dismissableMask]="true"
    [contentStyle]="{'display': 'flex', 'flexDirection': 'column', 'height': '100%' , 'justify-content' : 'space-between'}"
    [draggable]="true" [resizable]="true" [maximizable]="true" (onShow)="onEditDialogShow()">

    <!-- Single row: Dropdown + Radio buttons (Editor / Document Upload) -->
    <div class="create-step-row">
        <div class="create-step-dropdown-cell">
            <label class="create-step-label">Select Type :</label>
            <p-dropdown [options]="documentTypes" [(ngModel)]="selectedType" placeholder="Select Type" [filter]="true"
                filterBy="label" optionLabel="label" styleClass="create-step-dropdown" [style]="{'width':'100%'}"
                [disabled]="viewMode">
            </p-dropdown>
        </div>
        <div class="create-step-radio-cell">
            <label class="create-step-label create-step-radio-label">Format :</label>
            <div class="create-step-radio-group">
                <p-radioButton name="editStepFormat" value="editor" [(ngModel)]="selectedFormat" inputId="edit_format_editor" [disabled]="viewMode"></p-radioButton>
                <label for="edit_format_editor" class="radio-label">Include Editor (rich text)</label>
                <p-radioButton name="editStepFormat" value="document" [(ngModel)]="selectedFormat" inputId="edit_format_document" class="ms-3" [disabled]="viewMode"></p-radioButton>
                <label for="edit_format_document" class="radio-label">Attach document (file upload)</label>
            </div>
        </div>
    </div>

    <!-- Rich text editor - shown when "Include Editor" is selected -->
    <div class="create-step-editor-section mb-4" *ngIf="selectedFormat === 'editor'">
        <form [formGroup]="stepForm">
            <div class="form-group mb-0 editor-container" *ngIf="!viewMode">
                <label class="bg-primary text-white p-2 d-block mb-0" for="editStepCommentEditor"><strong>Data <b class="text-danger">*</b></strong></label>
                <editor id="editStepCommentEditor" [init]="init" formControlName="comment"></editor>
            </div>
            <div class="form-group mb-0 editor-container" *ngIf="viewMode && (selectedItem?.paragraph_1 || stepForm.get('comment')?.value)">
                <label class="bg-primary text-white p-2 d-block mb-0" for="viewStepCommentEditor"><strong>Data <b class="text-danger">*</b></strong></label>
                <editor id="viewStepCommentEditor" [init]="initReadonly" formControlName="comment"></editor>
            </div>
        </form>
    </div>

    <!-- Document upload - shown when "Attach document" is selected -->
    <div class="create-step-upload-section mb-4" *ngIf="selectedFormat === 'document'">
        <label class="create-step-label mb-2">Choose File</label>
        <p-fileUpload *ngIf="!viewMode" mode="basic" chooseLabel="Choose File" accept=".pdf,.doc,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            [auto]="true" [maxFileSize]="209715200" [customUpload]="true" [multiple]="false"
            (uploadHandler)="onUpload($event)" #editFileUpload styleClass="p-button-outlined w-100">
        </p-fileUpload>
        <div class="mt-3" *ngIf="!viewMode && selectedFinalOfferFile">
            <div class="d-flex justify-content-between align-items-center">
                <span>{{ selectedFinalOfferFile.name }}</span>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearUpload()" title="Remove File">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>
        <div class="mt-3" *ngIf="finalOfferFilePath && finalOfferFileName">
            <div class="d-flex justify-content-between align-items-center">
                <span>{{ finalOfferFileName }}</span>
                <a [href]="apiUrl + finalOfferFilePath" target="_blank" class="btn btn-sm" title="View File">
                    <i class="pi pi-eye"></i>
                </a>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-end mt-4">
        <button type="submit" class="btn btn-primary me-2" (click)="onFormsubmit()"*ngIf="(selectedType?.value == 'eoi' || selectedType?.value == 'soc' || selectedType?.value == 'sotr' 
    || selectedType?.value == 'rfp') && !viewMode ">Submit</button>
    </div>
</p-dialog>

<p-dialog header="Delete Step Data" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }">
    <div class="delete-dialog mt-3">
         <i class="pi pi-trash text-danger custom-delete-icon"></i>
        <span>Are you sure , you want to delete step data ?</span>
        <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteequipment()" class="mt-2">
        </p-button>
    </div>
</p-dialog>